import {
  Component,
  OnInit,
  Input,
  Inject,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastProvider } from '@app/Notification/Toast/toast.provider';
import { ApiService } from '../../services/api.services';
import { MainService } from '../../services/main.services';

@Component({
  selector: 'add-entity-operation',
  templateUrl: 'add-entity-operation-dialog.component.html',
})
export class AddAEntityOperationDialog {
  entityOperation: any = {};
  entityList: any = [];
  operationList: any = [];

  constructor(
    public addDialog: MatDialogRef<AddAEntityOperationDialog>,
    @Inject(MAT_DIALOG_DATA) public entity: any,
    private api: ApiService,
    private mainService: MainService,
    private snackBar: MatSnackBar,
    private toastProvider: ToastProvider
  ) {}

  ngOnInit() {
    this.getEntitiesList();
    this.getOperationList();
  }

  getEntitiesList() {
    this.mainService.getSecurityEntities({}).subscribe((res) => {
      console.log(res);
      this.entityList = res;
    });
  }

  getOperationList() {
    this.mainService.getOperations({}).subscribe((res) => {
      this.operationList = res;
    });
  }

  onSubmit() {
    this.api.addEntityOperation(this.entityOperation).subscribe((res) => {
      if (res) {
        this.toastProvider.sendMessage('Entity and operation added.', 'success');
        // this.snackBar.open('Entity and operation added.', 'OK', {
        //   duration: 2000,
        // });
        this.addDialog.close({ event: 'Success' });
      }
    });
  }

  cancelPopup(): void {
    this.addDialog.close();
  }
}
